<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <!-- 캠페인 목록 조회 -->
      <cmp-list-comp ref="cmpList" @returnResult="onClickCampaign" @gridRefresh="clearCampaignInfo">
        <div slot="bottomRightArea">
          <md-card-actions md-alignment="space-between">
            <md-button class="md-info md-sm" @click="createCampaign">
              <md-icon>event_available</md-icon>
              신규 캠페인
            </md-button>
          </md-card-actions>
        </div>
      </cmp-list-comp>


      <!-- 캠페인 대상 교우 관리 (상세 정보) -->
      <div class="md-layout" v-show="this.isShowDetailInfo">
        <!--1. 교우 등록-->
        <div class="md-layout">
          <div class="md-layout-item md-size-20 no-padding">
            <md-card>
              <md-card-header md-alignment="space-between">
                <h4 class="title">
                  <md-icon>search</md-icon>
									캠페인 정보
                </h4>
              </md-card-header>
              <md-card-content>
                <table class="flex-table mb10">
                  <tr v-if="!isCampaignCreate">
                    <th>캠페인 ID</th>
                    <td>
                      <input type="text"
                        v-model="campaignInfo.CCmpId"
											 disabled
                      >
                    </td>
                  </tr>
                  <tr>
                    <th>캠페인명</th>
                    <td>
                      <input type="text"
                        v-model="campaignInfo.CCustGrpNm"
                      >
                    </td>
                  </tr>
                  <tr>
                    <th>설명</th>
                    <td>
                      <input type="text"
                        v-model="campaignInfo.CCustGrpDesc"
                      >
                    </td>
                  </tr>
                </table>
                <md-button
                  class="md-info md-sm full-size-button"
                  @click="addCampaign"
                >
                  <md-icon>check</md-icon>
                  {{isCampaignCreate ? '저장' : '수정'}}
                </md-button>
              </md-card-content>
            </md-card>

            <md-card v-if="!isCampaignCreate">
              <md-card-header md-alignment="space-between">
                <h4 class="title">
                  <md-icon>search</md-icon>
									대상자 추가
                </h4>
              </md-card-header>
              <md-card-content>
                <div class="flex-div mb10">
                  <h5 class="title">교우 검색 후 추가</h5>
                  <md-button
                    class="md-success md-sm full-size-button"
                    @click="() => {this.isShowUserModal = true}"
                  >
                    <md-icon>open_in_new</md-icon>
                    검색 팝업
                  </md-button>
                </div>
                <hr>
                <div class="flex-div">
									<h5 class="title">엑셀 업로드</h5>
									<div class="inline-flex mb10">
										<input type="file" class="hidden-input-file" id="excelFileInput" accept=".xlsx">
										<input type="text" v-model="excelFileName" disabled>
										<button @click="onClickSearchExcel()">
											<md-icon>search</md-icon>
											엑셀 파일 찾기
										</button>
									</div>
									<md-button class="md-success md-sm full-size-button"
														 @click="uploadExcelFile()"
														 :disabled="!excelFile"
									>
										<md-icon>publish</md-icon>
										엑셀 업로드
									</md-button>
                </div>
                <hr>
								<div class="flex-div">
									<h5 class="title">대상 복사 붙여 넣기</h5>
									<div class="inline-flex mb10">
                  <textarea rows="10" class="h200"
														v-model="textAreaData"
									></textarea>
									</div>
									<div class="inline-flex mb10">
										<select>
											<option>교우번호</option>
											<option>학번</option>
										</select>
									</div>
									<md-button class="md-success md-sm full-size-button" :disabled="String(textAreaData).trim().length < 7" @click="uploadMemberList">
										<md-icon>publish</md-icon>
										실행
									</md-button>
								</div>
              </md-card-content>
            </md-card>
          </div>
					<div class="md-layout-item md-size-80 no-padding">
						<md-card>
							<md-card-header md-alignment="space-between">
								<h4 class="title">
									<md-icon>assignment</md-icon>
									대상 교우 목록
								</h4>
							</md-card-header>
							<!-- 캠페인 대상 교우 목록 조회 -->
							<cmp-target-list-comp ref="cmpMemberList">
								<div slot="bottomRightArea">
									<md-card-actions md-alignment="space-between">
										<div>
											<md-button
												class="md-warning md-sm"
												@click="deleteCampaignMember"
											>
												<md-icon>person_remove</md-icon>
												캠페인 대상교우에서 제외
											</md-button>
											<!--md-button
												class="md-info md-sm"
											>
												<md-icon>check</md-icon>
												캠페인 대상교우 목록 저장
											</md-button-->
										</div>
									</md-card-actions>
								</div>
							</cmp-target-list-comp>
						</md-card>
					</div>
        </div>

        <!--교우선택 팝업 --><!--교우검색 팝업 -->
				<member-search-pop-comp :is-show.sync="isShowUserModal" @returnResult="onSelectedModalMember"></member-search-pop-comp>

      </div>
      <!-- 캠페인 대상 교우 관리 (상세 정보) 끝 -->
			<div id="scrollTargetBox"></div>
    </div>
  </div>
</template>

<script>

import kuaaApi from "@/kuaa/kuaa-api";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import parser from "@/kuaa/kuaa-parser";

import Swal from "sweetalert2";

import cmpListComp from "@/pages/Counselor/Components/cmpListComp";
import cmpTargetListComp from "@/pages/Counselor/Components/cmpTargetListComp";

import { MemberSearchPopComp } from "@/pages"


export default {
  components: {
    cmpListComp,
    cmpTargetListComp,
    MemberSearchPopComp
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  data(){
    return {
      isShowDetailInfo: false,
      isShowUserModal: false,
			isCampaignCreate : true, // 캠페인 신규 생성 여부
      campaignInfo: {
        CCmpId: "",
        CCustGrpNm: "",
        CCustGrpDesc: ""
      },
      excelFile : null,
      excelFileName : '',
      textAreaData : '',
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      }
    }
  },

  methods: {
    onClickCampaign(item) {
      this.campaignInfo = item;
      this.isCampaignCreate = false;
      this.isShowDetailInfo = true;
      this.$refs.cmpMemberList.sendQuery(this.campaignInfo.CCmpId);
      kuaaFnc.scrollTo('scrollTargetBox');
    },

	clearCampaignInfo(){
      this.isShowDetailInfo = false;
      this.isCampaignCreate = true;
      this.campaignInfo = {
        CCmpId: "",
        CCustGrpNm: "",
        CCustGrpDesc: ""
      };
      this.$refs.cmpMemberList.resetData();
    },

    createCampaign(){
      this.isShowDetailInfo = true;
      this.isCampaignCreate = true;
      this.campaignInfo = {
        CCmpId: "",
        CCustGrpNm: "",
        CCustGrpDesc: ""
      };
      this.$refs.cmpMemberList.resetData();
    },

	saveCampaign(){

      if(!this.campaignInfo.CCustGrpNm || this.campaignInfo.CCustGrpNm==''){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'캠페인명을 입력 해 주세요'}));
        return;
			}
      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "캠페인을 추가 하시겠습니까?",
      });
      Swal.fire(modalOptions).then(result => {
        if (result.value) {

          let params = {
            "cCustGrpNm" : this.campaignInfo.CCustGrpNm,
			      "cCustGrpDesc" : this.campaignInfo.CCustGrpDesc,
			      "calluseCd" : '00'
          };

          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.SAVE_CMP_PREVIEW,
            params,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `추가 되었습니다.`;
                Swal.fire(modalOptions);
                this.$refs.cmpList.sendQuery();
              } else {
                modalOptions.html = `캠페인 추가 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      });
		},

	editCampaign(){
      if(!this.campaignInfo.CCmpId || this.campaignInfo.CCmpId==''){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'캠페인명을 선택 해 주세요'}));
        return;
      }

      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "캠페인을 수정 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {

          // 배열 [] 제거 - 객체만 전송
          let params = {
            "cCustGrpNm" : this.campaignInfo.CCustGrpNm,
            "cCustGrpDesc" : this.campaignInfo.CCustGrpDesc,
            "cCmpId" : this.campaignInfo.CCmpId,
            "cCustGrpId" : this.campaignInfo.CCustGrpId
            // calluseCd는 UPDATE 쿼리에 없으므로 제거
          };

          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.MODIFY_CMP_PREVIEW,
            params,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `수정 되었습니다.`;
                Swal.fire(modalOptions);
                this.$refs.cmpList.sendQuery();
              } else {
                modalOptions.html = `캠페인 수정 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      });
		},

    addCampaign(){
      if(this.isCampaignCreate){
        this.saveCampaign();
			}else{
        this.editCampaign();
			}
		},

    onSelectedModalMember(item){
      this.parseAddCampaignMember([item.memberNo]);
		},

    onClickSearchExcel() {
      let input = document.getElementById("excelFileInput");
      input.onchange = e => {
        let file = e.target.files[0];
        this.excelFileName = file.name;
        this.excelFile = file;
      };
      input.click();
    },

    uploadExcelFile() {
      let xls = this.excelFile;
      parser.parseXlsMemberData(xls, (res)=>{
        this.parseAddCampaignMember(res)
      });
    },

    uploadMemberList() {
      let list = this.textAreaData.split("\n");
      let memberArr = [];
      list.forEach((item)=>{
        memberArr.push(item);
      })
      this.parseAddCampaignMember(memberArr);
    },

		parseAddCampaignMember(items){
      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "대상 교우에 추가 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          let params = [];
          items.forEach((mId)=>{
            params.push({
              "cCmpId" : this.campaignInfo.CCmpId,
              "cCustGrpId" : this.campaignInfo.CCustGrpId,
              "cCustId" : mId != null? mId.trim() : mId
            });
          });
          this.addCampaignMember(params);
        }
      });
		},

		addCampaignMember(params){
      let modalOptions = kuaaFnc.getSwalModaloptions();
      kuaaApi.sendServer(
        URL_CONST.SAVE_CMP_RESULT_LIST,
        params,
        "post",
        response => {
          if (response.data.success){
            modalOptions.html = `추가 되었습니다.`;
            Swal.fire(modalOptions);
            this.$refs.cmpMemberList.sendQuery(this.campaignInfo.CCmpId);
            this.textAreaData = '';
          } else {
            modalOptions.html = `대상교우 추가 실패 하였습니다.`;
            Swal.fire(modalOptions);
          }
        }
      );
		},

		deleteCampaignMember(){
      let checkedRows = this.$refs.cmpMemberList.getSelectedMember();

      if(checkedRows.length < 1){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'대상교우를 선택 해 주세요'}));
        return;
			}

      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "대상 교우를 삭제 하시겠습니까?"
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          let params = [];

          checkedRows.forEach((obj)=>{
            params.push({
              "cCmpId" : this.campaignInfo.CCmpId,
              "cCustGrpId" : this.campaignInfo.CCustGrpId,
              "cCustId" : obj.cCustId
            })
					})

          kuaaApi.sendServer(
            URL_CONST.REMOVE_CMP_RESULT_LIST,
            params,
            "post",
            response => {
              let modalOptions = kuaaFnc.getSwalModaloptions();
              if (response.data.success){
                modalOptions.html = `삭제 되었습니다.`;
                Swal.fire(modalOptions);
                this.$refs.cmpMemberList.sendQuery(this.campaignInfo.CCmpId);
              } else {
                modalOptions.html = `대상교우 삭제 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );

        }
      });

		}

  }
}
</script>

<style>

</style>